import axios from 'axios';
import BaseUrl from '../../utils/api.js';

export default class PTOService {

    static getPTOListResult(CompanyCode, list, ActionType) {

        var data={
            CompanyCode: CompanyCode,
            list: list,
            ActionType:ActionType
        }  
        return axios.post(BaseUrl+ 'PTO', data);
    }

    static SavePTO(CompanyCode, list, ActionType, email) {

        var data={
            CompanyCode: CompanyCode,
            list: list,
            ActionType:ActionType
        }  
        return axios.post(BaseUrl+'SavePTO?email='+email, data);
    }
}


// WEBPACK FOOTER //
// ./src/Services/PTOService/ptoService.js